import {GameState, PerformActionRequest, SaveGameRequest} from "@shared/types";
import {getJsonApi, getPlayerSessionId, postJsonApi} from "../helpers";
import {Save} from "../components/SavePopup";
import {User} from "../models/User";

export async function getState(): Promise<GameState> {
    return getJsonApi<GameState>("game/state/");
}

export async function getUserByUsername(username: string): Promise<User> {
    return getJsonApi<User>(`users/getBy/${username}`);
}

export async function getSaves(token: string): Promise<Save[]> {
    return getJsonApi<Save[]>("save/getSavesForCurrentUser", null, token);
}

export async function performAction(
    actionAlias: string,
    objectAliases?: string[]
): Promise<GameState | undefined> {
    try {
        return postJsonApi<GameState, PerformActionRequest>("game/action/", {
            action: actionAlias,
            objects: objectAliases,
        });
    } catch {
        return undefined;
    }
}

export async function Login(
    username: string,
    password: string
): Promise<any | undefined> {
    try {
        return postJsonApi<any, any>("auth/signin/", {
            username: username,
            password: password,
        });
    } catch {
        return undefined;
    }
}

export async function Register(
    username: string,
    password: string
): Promise<any | undefined> {
    try {
        return postJsonApi<any, any>("auth/signup/", {
            username: username,
            password: password,
        });
    } catch {
        return undefined;
    }
}


export async function resetCurrentPlayerSession(
): Promise<any | undefined> {
    try {
        return postJsonApi<any, any>(`game/resetPlayerSession/${getPlayerSessionId()}`, null);
    } catch {
        return undefined;
    }
}

export async function loadSave(
    saveId: string,
    token: string
): Promise<any | undefined> {
    try {
        return postJsonApi<Save, null>(`save/load/${saveId}`, null, token);
    } catch {
        return undefined;
    }
}

export async function deleteSave(
    saveId: string,
): Promise<any | undefined> {
    try {
        return postJsonApi<Save, null>(`save/delete/${saveId}`, null);
    } catch {
        return undefined;
    }
}

export async function saveGame(
    sessionId: string,
    token: string,
    saveId?: string,
): Promise<any | undefined> {
    try {
        return postJsonApi<Save, SaveGameRequest>("save/save/", {
            session_id: sessionId,
            save_id: saveId,
        }, token);
    } catch {
        return undefined;
    }
}


